import * as React from "react";
import { Link } from "react-router-dom";
import { Monitor, ArrowLeftRight, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";

export const ToolCards = () => {
  return (
    <div className="flex justify-center gap-2 sm:gap-4 mt-6">
      {/* Can My PC Run It Card */}
      <Link to="/bilgisayarim-acar-mi" className="group" data-testid="tool-canrun-btn">
        <Card className="w-[105px] h-[105px] sm:w-44 sm:h-44 flex flex-col items-center justify-center gap-1.5 sm:gap-3 rounded-xl sm:rounded-2xl border-cyan-500/30 bg-gradient-to-br from-cyan-500/10 via-blue-500/5 to-transparent hover:from-cyan-500/20 hover:via-blue-500/10 hover:border-cyan-400/50 transition-all duration-300 cursor-pointer group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(6,182,212,0.2)]">
          <div className="size-10 sm:size-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center group-hover:from-cyan-500/30 group-hover:to-blue-500/30 transition-all">
            <Monitor className="size-5 sm:size-7 text-cyan-400" />
          </div>
          <div className="text-center px-1">
            <p className="font-semibold text-[10px] sm:text-sm text-foreground">PC Test</p>
            <p className="text-[8px] sm:text-[10px] text-muted-foreground mt-0.5 hidden sm:block">Bilgisayarım Açar Mı?</p>
          </div>
        </Card>
      </Link>

      {/* Game Comparison Card */}
      <Link to="/karsilastir" className="group" data-testid="tool-compare-btn">
        <Card className="w-[105px] h-[105px] sm:w-44 sm:h-44 flex flex-col items-center justify-center gap-1.5 sm:gap-3 rounded-xl sm:rounded-2xl border-purple-500/30 bg-gradient-to-br from-purple-500/10 via-pink-500/5 to-transparent hover:from-purple-500/20 hover:via-pink-500/10 hover:border-purple-400/50 transition-all duration-300 cursor-pointer group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(168,85,247,0.2)]">
          <div className="size-10 sm:size-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center group-hover:from-purple-500/30 group-hover:to-pink-500/30 transition-all">
            <ArrowLeftRight className="size-5 sm:size-7 text-purple-400" />
          </div>
          <div className="text-center px-1">
            <p className="font-semibold text-[10px] sm:text-sm text-foreground">Karşılaştır</p>
            <p className="text-[8px] sm:text-[10px] text-muted-foreground mt-0.5 hidden sm:block">Oyunları Karşılaştır</p>
          </div>
        </Card>
      </Link>

      {/* Game Recommendation Card */}
      <Link to="/oyun-oneri" className="group" data-testid="tool-recommend-btn">
        <Card className="w-[105px] h-[105px] sm:w-44 sm:h-44 flex flex-col items-center justify-center gap-1.5 sm:gap-3 rounded-xl sm:rounded-2xl border-amber-500/30 bg-gradient-to-br from-amber-500/10 via-orange-500/5 to-transparent hover:from-amber-500/20 hover:via-orange-500/10 hover:border-amber-400/50 transition-all duration-300 cursor-pointer group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(245,158,11,0.2)]">
          <div className="size-10 sm:size-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-amber-500/20 to-orange-500/20 flex items-center justify-center group-hover:from-amber-500/30 group-hover:to-orange-500/30 transition-all">
            <Sparkles className="size-5 sm:size-7 text-amber-400" />
          </div>
          <div className="text-center px-1">
            <p className="font-semibold text-[10px] sm:text-sm text-foreground">Oyun Bul</p>
            <p className="text-[8px] sm:text-[10px] text-muted-foreground mt-0.5 hidden sm:block">Sana Uygun Oyun</p>
          </div>
        </Card>
      </Link>
    </div>
  );
};
